// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2ys-D","header":"PatientBlock_header__3rNIv","label":"PatientBlock_label__3yqmS","option":"PatientBlock_option__3gyEW"};